<template>
    <div>
        <b-link :to="{name:'basic-dataloghome'}" class="preTitle" style="color: #5E8F23">{{preTitle}}</b-link>
        <b-button class="plusButton mr-1 px-0 pt-0 pb-0">
            <b-link :to="{ name: 'advance-dataloghome' }">
                <b-img width="50px" 
                    src="@/assets/images/ganImage/icons/add.png"
                />
            </b-link>
        </b-button>
    </div>
</template>

<script>
import {BImg, BLink, BButton} from 'bootstrap-vue'
export default {
    props:{
        preTitle:String
    },
    components: {
        BImg,
        BLink,
        BButton,
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss">

.plusButton {
    background-color: transparent !important;
    position: absolute;
    border: 0;
    top:83%;
    right:1%;
    //border-radius:50%;
}

.preTitle {
    position: absolute;
    top:85%;
    right:20%;
    color: #5E8F23;
    font-weight: 600;
    font-size: medium;
}
</style>